import Request from "@wwdev/bootstrap/Request";
import Map from "@/vendor/Dealer/GoogleMaps";
import getCurrentLocation from "@/vendor/getCurrentLocation";

class BaseDealerSelect {
	map;

	initialised = false;

	constructor(config) {
		this.config = config;
		this.$scope = $(config.scope);
		if (this.$scope.length > 0) {
			this.init();
		}
	}

	async init() {
		this.map = new Map({ scope: this.config.scope });
		this.request = new Request();
		this.addEventListeners();
		this._getCurrentPosition();
	}

	addEventListeners() {
		this.$scope
			.on('change', this.config.addressFields.join(', '), this.onAddressChange.bind(this))
			.on('click', this.config.open, this.open.bind(this))
			.on('click', this.config.close, this.close.bind(this))
			.on('click', this.config.selectByList, (e) => {
				e.preventDefault();
				let id = $(e.currentTarget).closest(this.config.list).find('input[name="dealer"]:checked').val();
				this.setDealer(id);
			})
			.on('click', this.config.selectByMap, (e) => {
				e.preventDefault();
				this.setDealer($(e.currentTarget).data('dealer-select'));
			});

		$('#nav-map-tab').on('click', () => this.map.zoom());
	}

	onAddressChange() {
		if (this.initialised) {
			this.search();
		}
	}

	setSearchField() {
		const get = (name) => this.$scope.find(`[name="${name}"]`).val();
		const { addressMap } = this.config;

		let zipcode = get(addressMap.zipcode);
		let street = get(addressMap.street);
		let street_number = get(addressMap.street_number);
		let street_number_extra = get(addressMap.street_number_extra) || '';
		let town = get(addressMap.town);
		if (zipcode.length < 6 || street.length < 1 || street_number.length < 1 || town.length < 1) {
			return false;
		}
		this.request.request.search = `${street} ${street_number}${street_number_extra}, ${zipcode} ${town}`;
		return true;
	}

	_getCurrentPosition() {
		return getCurrentLocation().then((data) => {
			if(!data) {
				return;
			}

			let $street = this.$scope.find(`[name="${this.config.addressMap.street}"]`);
			let $streetNumber = this.$scope.find(`[name="${this.config.addressMap.street_number}"]`);
			let $town = this.$scope.find(`[name="${this.config.addressMap.town}"]`);
			let $zipcode = this.$scope.find(`[name="${this.config.addressMap.zipcode}"]`);

			$street.val(data.street);
			$streetNumber.val(data.street_number);
			$town.val(data.town);
			$zipcode.val(data.zipcode);
		});
	}

	async search() {
		if (!this.setSearchField()) return false;

		const response = await $.ajax({
			url: this.$scope.data('dealer-url'),
			method: 'get',
			data: {
				...this.request.request,
				range: 20,
				action: 'getDealersForSelect',
			},
		});

		this.$scope.find(this.config.list).html(response.list);
		this.map.setMarkers(response.markers);

		return true;
	}

	async open(e) {
		const get = (name) => this.$scope.find(`[name="${name}"]`).val();
		const { addressMap } = this.config;
		let zipcode = get(addressMap.zipcode);

		let $postcodeError = $("#postcodeError");
		if (!zipcode || zipcode.trim().length === 0) {
			e?.preventDefault(); // blokkeer openen
			let $zipcodeInput = this.$scope.find(`[name="${addressMap.zipcode}"]`);

			$zipcodeInput.addClass("error");
			$postcodeError.show();
			return;
		}

		this.$scope.find(`[name="${addressMap.zipcode}"]`).removeClass("error");
		$postcodeError.hide();

		if (!this.initialised) {
			await this.map.init();
			await this.search();
			this.initialised = true;
		}
		this.showUI();
		this.map.zoom();
	}


	async setDealer(id) {
		const response = await $.ajax({
			url: this.$scope.data('dealer-url'),
			method: 'get',
			data: {
				dealer_id: id,
				action: 'getDealer',
			},
		});
		this.$scope.find(this.config.input).html(response.html);
		this.close();
	}

	showUI() {}

	close() {}
}

export default BaseDealerSelect;